(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["salted-caramel-campaign"] && !Shopify.designMode) return;
  try {
    class SaltedCaramelCampaign extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.options = [...this.querySelectorAll('[name="quantity"]')];
      this.options.forEach(option => { option.dataset.unavailable = String(option.disabled); });
      const first = this.options.find(option => !option.disabled);
      if (first) first.checked = true;
      this.button.disabled = !first;
      this.form.addEventListener('submit', event => this.add(event), { signal });
      document.addEventListener('cart:update', () => this.refresh(), { signal });
      window.addEventListener('pageshow', () => this.refresh(), { signal });
      this.refresh();
    }
    disconnectedCallback() { this.controller.abort(); }
    url(path) { return this.dataset.root.replace(/\/?$/, '/') + path; }
    async refresh() {
      try {
        const response = await fetch(this.url('cart.js'), { signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        const count = cart.items.filter(item => String(item.product_id) === this.dataset.productId && !item.selling_plan_allocation && !item.properties?._bundle_id && !item.properties?._bundle_type).reduce((sum, item) => sum + item.quantity, 0);
        const tier = [{ quantity: 3, percent: 10 }, { quantity: 6, percent: 12 }, { quantity: 9, percent: 14 }].find(tier => tier.quantity > count);
        const message = tier ? this.dataset.progress.replace('[remaining]', String(tier.quantity - count)).replace('[percent]', String(tier.percent)) : this.dataset.unlocked;
        this.querySelector('[data-progress-text]').textContent = message.replace('[count]', String(count));
      } catch (_) {}
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      this.busy = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      const error = this.querySelector('[data-error-text]');
      error.hidden = true;
      try {
        const quantity = Number(new FormData(this.form).get('quantity'));
        if (![3, 6, 9].includes(quantity)) throw new Error('Invalid quantity');
        const response = await fetch(this.url('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity }] })
        });
        if (!response.ok) throw new Error('Cart add failed');
        window.location.assign(this.url('cart'));
      } catch (_) {
        error.textContent = this.dataset.error;
        error.hidden = false;
        this.querySelector('[data-review-cart]').hidden = false;
        await this.refresh();
        this.busy = false;
        this.button.disabled = true;
        this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('salted-caramel-campaign')) customElements.define('salted-caramel-campaign', SaltedCaramelCampaign);
  } catch(e) { console.error(e); }
})();

})();
